exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.container[data-v-c2fc4ade]{\n    display: block;\n}\n", ""]);

